export const CATALOGUE_FIELDS = {
  Id: "catalogueItems__Id",
  ItemsCode: "catalogueItems__Code",
  Active: "catalogueItems__bActive",
} as const;

export const SHOP_CONFIG = {
  /** Fallback currency symbol */
  FALLBACK_CURRENCY_SYMBOL: "£",
  /** Toast message auto-hide duration in milliseconds */
  TOAST_DURATION: 5500,
  /** Card layout configuration */
  CARD_LAYOUT: 4,
} as const;
